/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating
 */
export interface FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating {
    /**
     * Средний рейтинг (1.0 - 5.0)
     * @type {number}
     * @memberof FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating
     */
    AverageRating?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating
     */
    ReviewCount?: Array<number> | null;
}

/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating(value: object): value is FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating {
    return true;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating {
    return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating {
    if (json == null) {
        return json;
    }
    return {
        
        'AverageRating': json['AverageRating'] == null ? undefined : json['AverageRating'],
        'ReviewCount': json['ReviewCount'] == null ? undefined : json['ReviewCount'],
    };
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingToJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating {
    return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AverageRating': value['AverageRating'],
        'ReviewCount': value['ReviewCount'],
    };
}

